Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgSettings = void 0;

var core_1 = require("@emotion/core");

var styled_system_1 = require("@wheelroom/styled-system");

var componentId = 'svg-settings';

exports.SvgSettings = function (props) {
  var strokeWidth = props.strokeWidth || 2;
  var css = styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, props.ncss);
  return core_1.jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "settings_svg__feather settings_svg__feather-settings",
    css: css,
    id: componentId,
    width: "100%"
  }, core_1.jsx("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), core_1.jsx("path", {
    d: "M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"
  }));
};